import PropTypes from 'prop-types';
import React, { Component } from 'react';
import urljoin from 'url-join';
import Select from '../../Select';

class VersionSelector extends Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(evt) {
    const { meta } = this.props;
    const { baseUrl } = meta.versioning;
    const version = evt.target.value;

    // Resolve the path of the article relative to the topic's base URL.
    const path = meta.url.replace(urljoin(baseUrl, meta.version), '');

    // Redirect to the corresponding article in the new target version.
    // NB: We can't do a partial refresh with navigateAction here, because we may end
    // up needing to redirect if the article doesn't exist in the target version.
    document.location = path.length > 0
      ? urljoin(baseUrl, version, path)
      : urljoin(baseUrl, version);
  }

  render() {
    const { meta: { version, versioning } } = this.props;

    const options = versioning.versions.map(value => ({
      label: value,
      value
    }));

    return (
      <Select
        options={options}
        selected={options.findIndex(v => v.value === version)}
        handleChange={this.handleChange}
        label="Version"
      />
    );
  }

}

VersionSelector.propTypes = {
  meta: PropTypes.object
};

export default VersionSelector;
